import { UsersFormDataTenantUserInvite } from '@/common/viewModels/users/form/data/UsersFormDataTenantUserInvite';
import { UserDetailsFormDataUserEdit } from '@/common/viewModels/userDetails/form/data/UserDetailsFormDataUserEdit';
import { TenantUser, UserDetail } from '@/common/models';

export class UsersHelper {
  static getTenantUser(data: UsersFormDataTenantUserInvite): TenantUser {
    return {
      id: '',
      name: data.firstName + ' ' + data.lastName,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      tenantId: '',
      status: '',
      lastLogin: undefined,
      invitationTimeUtc: undefined,
      picture: '',
      role: data.role,
    };
  }

  static getUpdateTenantUser(tenantUser: TenantUser, data: UserDetailsFormDataUserEdit): TenantUser {
    return {
      ...tenantUser,
      firstName: data.firstName,
      lastName: data.lastName,
      role: data.role,
    };
  }

  static getUserDisplayName(user: UserDetail | TenantUser): string {
    return user.name || user.email || '';
  }
}
